import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;

const echo = new Echo({
    broadcaster: 'reverb',
    key: process.env.VITE_REVERB_APP_KEY || 'kst7trruea2q9wsbvedn',
    wsHost: process.env.VITE_REVERB_HOST || 'localhost',
    wsPort: process.env.VITE_REVERB_PORT || 8080,
    wssPort: process.env.VITE_REVERB_PORT || 8080,
    forceTLS: (process.env.VITE_REVERB_SCHEME || 'http') === 'https',
    enabledTransports: ['ws', 'wss'],
});

export default echo;
